import { styled } from '@mui/material/styles'

export const TabWrapper = styled('div')(`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 16px 20px;
`)

export const TabItem = styled('span')(
  ({ active }) => `
  font-size: 14px;
  font-weight: 400;
  color: ${active ? '#0066DB' : '#333333'};
  border-bottom: 2px solid ${active ? '#0066DB' : 'transparent'};
  cursor: pointer;
  &:hover {
    color: #0066DB;
  }
`
)
